import { ReactNode, useState } from 'react';
import { useMemo } from 'react';

import { useSanitize } from '../../../../../utils/useSanitize';

type ReturnType = { component: ReactNode; hook: [boolean, (v: boolean) => void] };
const format = (html: string, linkColor: string, textColor: string): string => {
	const parser = new DOMParser();
	const parsed = parser.parseFromString(html, 'text/html');
	return [...(parsed.body.childNodes as unknown as Element[])]
		.map((сhild) => {
			if (сhild.tagName && сhild.tagName === 'A') {
				(сhild as HTMLAnchorElement).target = '_blank';
				(сhild as HTMLAnchorElement).style.color = linkColor;
				return сhild.outerHTML;
			} else if (!сhild.tagName) {
				return `<span style="color:${textColor} !important">${(сhild as unknown as Text).data}</span>`;
			} else {
				(сhild as HTMLElement).style.color = textColor;
				return сhild.outerHTML;
			}
		})
		.join('');
};
export const useAgreement = (HTML: string, linkColor: string, textColor: string): ReturnType => {
	const agreementHtml = useSanitize(HTML);
	const checkboxStateHook = useState(!agreementHtml);
	const component = useMemo(() => {
		if (agreementHtml) {
			const data = {
				__html: format(agreementHtml.__html, linkColor, textColor),
			};
			return <div dangerouslySetInnerHTML={data} />;
		} else return null;
	}, [agreementHtml, linkColor, textColor]);

	return { component, hook: checkboxStateHook };
};
